var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalChillerValve = function SvgPSignalChillerValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 304.1,
    y1: 188.1,
    x2: 78.1,
    y2: 188.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPSignalChillerValve;